module.exports = __webpack_public_path__ + "static/media/Leave.4145b294.svg";